import React from 'react';
import {createPortal} from 'react-dom';
import MessagePeek from './message-peek';

/**
 * Renders open Contact Us message peeks above the page (portal) so grid scroll does not clip them.
 *
 * @param {{
 *   openIds: string[],
 *   focusedId?: string | null,
 *   origins?: Record<string, {x: number, y: number}>,
 *   resolveMessage: (id: string) => object | null | undefined,
 *   loading?: boolean,
 *   onFocus?: (id: string) => void,
 *   onClose?: (id: string) => void,
 *   onMarkAsRead?: (id: string) => void,
 *   onRemove?: (message: object) => void,
 * }} props
 */
const MessagePeeksHost = ({
    openIds = [],
    focusedId = null,
    origins = {},
    resolveMessage,
    loading = false,
    onFocus,
    onClose,
    onMarkAsRead,
    onRemove,
}) => {
    if (typeof document === 'undefined' || !openIds?.length) {
        return null;
    }

    return createPortal(
        <>
            {openIds.map((id, cascadeIndex) => {
                const message = resolveMessage?.(id);
                const origin = origins[id] ?? origins[String(id)] ?? null;
                if (!message || !origin) {
                    return null;
                }
                return (
                    <MessagePeek
                        key={id}
                        message={message}
                        cascadeIndex={cascadeIndex}
                        origin={origin}
                        focused={focusedId === id || (!focusedId && cascadeIndex === openIds.length - 1)}
                        loading={loading}
                        onFocus={() => onFocus?.(id)}
                        onClose={() => onClose?.(id)}
                        onMarkAsRead={onMarkAsRead}
                        onRemove={onRemove}
                    />
                );
            })}
        </>,
        document.body,
    );
};

export default MessagePeeksHost;
